export function setwallet(state, wallet){
    state.wallet = wallet
    state.loading.wallet = true
}
export function settransactions_wallet(state, transactions_wallet){
    state.transactions_wallet = transactions_wallet
}

export function update_document(state,update_user){
    let wallet = state.wallet
    wallet.map(d=>{
        if(d.affects_document_id == update_user.document_id){
            d.tracing_user_update = update_user.tracing_user_updates;
        }
    })
    state.wallet = wallet

  }

export function setWalletType(state, wallet_types){
    state.wallet_types = wallet_types
}
export function setParamsWalletType(state, wallet_type){
    state.params.wallet_type = wallet_type
}

export function setbankaccount(state,accounts_bank){
    state.accounts_bank = accounts_bank;
}

export function setBranchofficeWarehouses(state,warehouse){
    state.warehouses = warehouse;
}

export function setConcepts(state,concepts){
    state.concepts = concepts;
}

export function setParameterContactWarehouse(state,parameterContactWarehouse){
    state.parameterContactWarehouse = parameterContactWarehouse;
}

export function setConceptsParameters(state,conceptsParameters){
    state.conceptsParameters = conceptsParameters;
}

export function setFunctions(state, functions){
    state.functions = functions
}
export function setGEVouchers_types(state, g_e_vouchers_types){
    state.g_e_vouchers_types = g_e_vouchers_types
}
export function setCreatedDocuments(state, created_documents){
    state.created_documents = created_documents
}
export function setTracings(state, tracings){
    state.tracings = tracings
}
export function setTracingDataDefault(state){
    let user = JSON.parse(localStorage.getItem('user'))
    let date_time = getTime();
    const time = date_time.time;
    const fechaEnFormato = date_time.date;
    state.tracing_fields = {
        id : null,
        tracing: null,
        time: time,
        user_id: user ?user.id:null,
        date: fechaEnFormato,
        document_id : null
    }
}
export function setTracingDataDefaultFileds(state){
    let user = JSON.parse(localStorage.getItem('user'))
    let date_time = getTime();

    const fechaEnFormato = date_time.date;
    const time = date_time.time;
    const doc_id = state.tracing_fields.document_id;

    state.tracing_fields = {
        id : null,
        tracing: null,
        time: time,
        user_id: user ?user.id:null,
        date: fechaEnFormato,
        document_id : doc_id
    }
}
export function updateTracingsRow(state){
    let tracings = state.tracings;
   if (tracings  && state.tracing_fields.document_id){
      let wallet = state.wallet;
      wallet.map(d=>{
          if(d.affects_document_id === state.tracing_fields.document_id){
              d.last_tracing = tracings.length >0 ?tracings[0].tracing:null;
              d.date_tracing = tracings.length >0 ?tracings[0].date_tracing:null;
              d.tracings = tracings;
          }
      })
      state.wallet = wallet
  }
}
export function setUpdatedTracing(state,tracing) {
    let date  =tracing.date_tracing.split(' ');
    state.tracing_fields = {
        id: tracing.id,
        tracing: tracing.tracing,
        time: date[1],
        user_id: tracing.user_id,
        date: date[0],
        document_id: tracing.document_id
    }
}
export function getTime(){
    const fechaActual = new Date();
    const year = fechaActual.getFullYear();
    const month = String(fechaActual.getMonth() + 1).padStart(2, '0'); // Sumamos 1 al mes ya que los meses comienzan desde 0
    const day = String(fechaActual.getDate()).padStart(2, '0');
    const hours = fechaActual.getHours().toString().padStart(2, '0');
    const minutes = fechaActual.getMinutes().toString().padStart(2, '0');
    const seg = fechaActual.getSeconds().toString().padStart(2, '0');

    return {
        'date': `${year}-${month}-${day}`,
        'time': `${hours}:${minutes}:${seg}`
    }

}
export function setIsLockRecordButton (state) {
    state.is_lock_record_button = !state.is_lock_record_button;
}

export function setSubscriber(state, subscriber){
    state.subscriber = subscriber
}


// WEBPACK FOOTER //
// ./src/modules/receivable-report/mutations.js